import './ListicleItem.css';
import React from 'react';
import { get } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import LazyPicture from '../atoms/LazyPicture';
import Video from '../atoms/Video';
import { tealiumClickFunc, tealiumMergeClickData, getLastPartInURL } from '../../utils/tealium';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
export const ListicleItem = _ref => {
  let {
    fields,
    index = 1,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const moduleId = get(fields, 'data.item.id');
  if (!fields.data.item) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  if (!fields) {
    console.info('ListicleItem component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[ListicleItem component is empty: please provide datasource]");
    }
    return null;
  }
  const {
    videoAnalytics,
    prevNextNavAnalytics,
    navBubblesAnalytics,
    readMoreAnalytics
  } = fields.data;
  const itemCaption = get(fields.data.item, 'caption.jss');
  const itemImage = get(fields.data.item, 'image.jss.value.src');
  const itemImageAlt = get(fields, 'data.item.image.jss.value.alt') || '';
  const videoSrc = get(fields.data.item, 'video.jss.value.href');
  const videoType = get(fields.data.item, 'video.jss.value.linktype');
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__media"
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__media-outer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "listicle__media-inner listicle__media-inner--poster-show"
  }, itemImage && /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    className: "listicle__image-box"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width:1200px)",
    srcSet: `${itemImage + '&cw=1420&ch=710'}`
  }), /*#__PURE__*/React.createElement("source", {
    media: "(min-width:769px)",
    srcSet: `${itemImage + '&cw=1180&ch=590'}`
  }), /*#__PURE__*/React.createElement("source", {
    media: "(max-width:768px)",
    srcSet: `${itemImage + '&cw=325&ch=243'}`
  }), /*#__PURE__*/React.createElement("img", {
    src: `${itemImage + '&cw=1420&ch=710'}`,
    className: "listicle__img",
    alt: `${itemImageAlt}`
  })), videoSrc && /*#__PURE__*/React.createElement(Video, {
    buttonTopAlignment: true,
    className: "media-wrapper__video ",
    videoSrc: videoSrc,
    videoType: videoType,
    click: e => tealiumClickFunc(tealiumMergeClickData(videoAnalytics, params), `${e}: ${getLastPartInURL(videoSrc)}`)
  }), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: "listicle__fav-btn test"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "listicle__caption body-small"
  }, " ", itemCaption && /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    field: itemCaption,
    "data-cy": ""
  }))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    componentTabIndex: "disabled"
  }, children);
};
export const commonStyles = "czhyhj1";
export const ltrStyles = "l12bpxma";
export const rtlStyles = "r1feoyl9";
export default ListicleItem;